import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    DispatchLoadOrderIfNeeded,
    DispatchSetCartId,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/DisplayOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartId: string;
    } & HasOnError,
    GetCartApiParameter,
    CartModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ["cartLines", "hiddenproducts", "restrictions"],
    } as GetCartApiParameter;
};

export const chain = [PopulateApiParameter, DispatchSetCartId, DispatchLoadOrderIfNeeded];

const displayOrder = createHandlerChainRunner(chain, "DisplayOrder");
export default displayOrder;
